import { render } from "./DataLoader.vue?vue&type=template&id=cbf2244a&scoped=true"
import script from "./DataLoader.vue?vue&type=script&lang=js"
export * from "./DataLoader.vue?vue&type=script&lang=js"

import "./DataLoader.vue?vue&type=style&index=0&id=cbf2244a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbf2244a"]])

export default __exports__